module.exports = __webpack_public_path__ + "static/img/bgProducts.c6aafb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bgProducts.png
// module id = ntuN
// module chunks = 13